import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
  input: {
    padding: '0 0 0 8px',
    fontSize: '1rem',
  },
  dateInput: {
    padding: '8px',
  },
  rootDateInput: {
    width: '170px',
    fontSize: '1rem',
    paddingRight: '0px',
  },
  outlined: {
    height: '35px',
    width: '35px',
  },
  outlinedError: {
    height: '35px',
    width: '35px',
    color: theme.palette.error.main,
  },
  span: {
    marginRight: '5px',
  },
  labelInput: {
    transform: 'scale(1) translate(-0%, 0%)',
  },
}));
